import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getPendingSummary } from '../Engagements/engagementsApi';

/** Dashboard card: engagements with documents waiting for the org's signature. */
export default function PendingSignaturesCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    getPendingSummary().then(setData).catch(() => setData(null));
  }, []);

  if (!data || !data.engagements || data.engagements.length === 0) return null;

  return (
    <section className="uh-section">
      <div className="uh-section-hdr">
        <div className="uh-section-title" style={{ marginBottom: 0 }}>
          <i className="fas fa-file-signature" style={{ marginRight: 8, color: '#1d4ed8' }} />
          {t('UserHome.serviceOnboarding', 'Service onboarding')}
          {data.pendingDocuments > 0 && <span className="uh-badge-red">{data.pendingDocuments}</span>}
        </div>
        <div className="uh-link-nav" onClick={() => navigate('/dashboard/engagements')}>
          {t('UserHome.viewAll', 'View all')} <i className="fas fa-arrow-right" />
        </div>
      </div>
      <ul className="uh-alert-list">
        {data.engagements.map((e) => (
          <li key={e.id} className="uh-alert-item" onClick={() => navigate(`/dashboard/engagements/${e.id}`)}>
            <span className="uh-alert-dot" />
            <div className="uh-alert-info">
              <span className="uh-alert-name">{e.serviceLabel} · {e.reference}</span>
              <span className="uh-alert-time">
                {e.pendingDocuments > 0
                  ? `${e.pendingDocuments} ${t('UserHome.docsToSign', 'document(s) waiting for your signature')}`
                  : e.status === 'AWAITING_COUNTERSIGN' ? t('UserHome.awaitingCataam', 'Signed — awaiting Cataam countersignature')
                    : e.status === 'REQUESTED' ? t('UserHome.underReview', 'Under review by Cataam') : e.status}
              </span>
            </div>
            <i className="fas fa-chevron-right uh-alert-arrow" />
          </li>
        ))}
      </ul>
    </section>
  );
}
